import { render, staticRenderFns } from "./NoTabberLayout.vue?vue&type=template&id=6cce44c8"
import script from "./NoTabberLayout.vue?vue&type=script&lang=js"
export * from "./NoTabberLayout.vue?vue&type=script&lang=js"
import style0 from "./NoTabberLayout.vue?vue&type=style&index=0&id=6cce44c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports